import { ComparisonTableProps } from '@eika/comparison-table/lib/ComparisonTableTypes';

import { hyphenAsSoftHyphen } from '../../utils/hyphenAsSoftHyphen';
import { spaceToNBSP } from '../../utils/spaceToNBSP';

const hestConfig: ComparisonTableProps = {
    tableHeadColumns: [
        {
            title: 'Ansvar',
            description: '',
        },
    ],
    rows: [
        {
            title: 'Liv',
            checkedRows: 1,
            help: 'Gir erstatning hvis hesten din dør eller blir borte. Dekker også utgiftene hvis hesten må avlives på grunn av ulykke eller skade.',
        },
        {
            title: `${hyphenAsSoftHyphen('Veterinær-utgifter')}`,
            checkedRows: 1,
            help: 'Dekker veterinærutgiftene til hesten.',
        },
        {
            title: `${hyphenAsSoftHyphen('Nød-slakt')}`,
            checkedRows: 1,
            help: `Hvis hesten dør eller må avlives ertsatter vi utgifter til nødslakt, bortkjøring og destruksjon av kadaver med inntil ${spaceToNBSP(
                '3 000',
            )} kroner.`,
        },
    ],
};

export default hestConfig;
